<template>
    <div class="bbp-timer-modal-panel-counter">
      {{counter}}
    </div>
</template>

<script>
import {TIMER_STATUS} from '@/constants/timerStatus'
export default {
  name: 'BBPTimerModalPanelCounter',
  props: {
    start: {
      type: Boolean,
      default: false
    },
    isPause: {
      type: Boolean,
      default: false
    },
    activeTimer: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    timerID: null
  }),
  computed: {
    counter () {
      const {hours, minutes, seconds} = this.time
      return `${hours}:${minutes}:${seconds}`
    },
    time: {
      get () {
        return this.$store.getters.time
      },
      set (data) {
        this.$store.dispatch('setTimer', data)
      }
    }
  },
  methods: {
    updateTime () {
      const {year, month, date, hours, minutes, seconds} = this.time
      const cd = new Date(year, month, date, hours, minutes, seconds)
      this.time = {
        year,
        month,
        date,
        hours: this.zeroPadding(cd.getHours(), 2),
        minutes: this.zeroPadding(cd.getMinutes(), 2),
        seconds: this.zeroPadding(cd.getSeconds() + 1, 2),
        fullDate: new Date()
      }
    },
    zeroPadding (num, digit) {
      let zero = ''
      for (let i = 0; i < digit; i++) {
        zero += '0'
      }
      return (zero + num).slice(-digit)
    }
  },
  watch: {
    start (newVal) {
      const { subTimers = {} } = this.activeTimer
      const { status = 0 } = subTimers
      if (!newVal) {
        this.timerID = setInterval(this.updateTime, 1000)
        return
      }
      clearTimeout(this.timerID)

      if (status !== TIMER_STATUS.COMPLETED) {
        this.time = {
          ...this.time,
          hours: '00',
          minutes: '00',
          seconds: '00'
        }
      }
    },
    isPause (newVal) {
      const { subTimers = {} } = this.activeTimer
      const { status = 0 } = subTimers
      if (newVal && status && status !== TIMER_STATUS.COMPLETED) {
        this.timerID = setInterval(this.updateTime, 1000)
        return
      }
      clearTimeout(this.timerID)
    }
  },
  beforeMount () {
    if (this.isPause && !this.start) this.timerID = setInterval(this.updateTime, 1000)
  },
  beforeDestroy () {
    clearTimeout(this.timerID)
  }
}
</script>

<style lang="scss" scoped>

  .bbp-timer-modal-panel-counter {
    font-size: 14px;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalPanel/BBPTimerModalPanelCounter.vue